import { InvoiceParameterRequest, InvoiceParameterForm, InvoiceParameterConfig } from "./invoice-parameter-types";

export const defaultFilter = (): InvoiceParameterRequest => ({
  carrierId: null,
  financialGroupId: null,
  contractId: null,
  subContractId: null,
  active: null,
});

export const defaultForm = (): InvoiceParameterForm => ({
  configs: [] as InvoiceParameterConfig[],
  ruleConfigId: null,
  carrierId: null,
  financialGroupId: null,
  contractId: null,
  subContractId: null,
  name: null,
  isApplicable: null,
  entityLevelName: null,
  entityLevel: null,
});

export const defaultConfig = (): InvoiceParameterConfig => {
  const tempId = Date.now();
  return {
    parentRuleConfigId: null,
    tempId: tempId,
    ruleId: null,
    active: false,
    description: null,
    observation: null,
    possibleValues: [],
    value: null,
    valueType: null,
    new: false,
    unlink: false,
  }
};